<script>
import { User } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'

export default {
  mixins: [FormMixin],
  data() {
    return {
      form: {
        is_staff: true,
        two_factor_auth: true
      },
      redirectRoute: { name: 'User List' }
    }
  },
  computed: {
    service() {
      return User
    }
  },
  methods: {
    getFields() {
      return [
        new fields.Input({
          label: 'Email',
          type: 'email',
          required: true,
          modelPath: [this, 'form', 'email']
        }),
        new fields.Input({
          label: 'First name',
          modelPath: [this, 'form', 'first_name']
        }),
        new fields.Input({
          label: 'Last name',
          modelPath: [this, 'form', 'last_name']
        }),
        new fields.Input({
          label: 'Password',
          required: true,
          type: 'password',
          modelPath: [this, 'form', 'password1'],
          condition: !this.form.id
        }),
        new fields.Input({
          label: 'Repeat password',
          required: true,
          type: 'password',
          modelPath: [this, 'form', 'password2'],
          condition: !this.form.id
        }),
        new fields.Switch({
          label: 'Is active',
          modelPath: [this, 'form', 'is_active']
        }),
        new fields.Switch({
          label: 'Is staff user',
          modelPath: [this, 'form', 'is_staff']
        }),
        new fields.Switch({
          label: '2FA enabled',
          modelPath: [this, 'form', 'two_factor_auth']
        }),
        new fields.Input({
          label: 'Phone number',
          type: 'tel',
          modelPath: [this, 'form', 'phone_number']
        })
      ]
    }
  }
}
</script>
